/// <reference types="./adminGetEntity.d.ts" />
import { authVerifyAuthorizationKey } from '../Auth.js';
import { decodeAdminEntity } from '../EntityCodec.js';
import { validateEntityReference } from '../utils/ValidationUtils.js';
export async function adminGetEntity(schema, authorizationAdapter, databaseAdapter, context, reference) {
    const validationResult = validateEntityReference(reference);
    if (validationResult.isError())
        return validationResult;
    const getResult = await databaseAdapter.adminEntityGetOne(context, reference);
    if (getResult.isError())
        return getResult;
    const entityValues = getResult.value;
    const authResult = await authVerifyAuthorizationKey(authorizationAdapter, context, {
        authKey: entityValues.authKey,
        resolvedAuthKey: entityValues.resolvedAuthKey,
    });
    if (authResult.isError())
        return authResult;
    return decodeAdminEntity(schema, entityValues);
}
//# sourceMappingURL=adminGetEntity.js.map